export const ru = {
    'empty-rate': 'Не указана',
    title: 'Редактирование ставки'
};
